import { apiRequest } from "@/lib/api/client";
import { getAuthToken } from "@/lib/auth/storage";
import type { ChatResponse, HealthResponse } from "@/lib/types";

function token() {
  return getAuthToken();
}

export const assistantApi = {
  chat(message: string, sessionId?: string) {
    const body: { message: string; session_id?: string } = { message };
    if (sessionId) {
      body.session_id = sessionId;
    }
    return apiRequest<ChatResponse>("/assistant/chat", {
      method: "POST",
      body,
      token: token(),
    });
  },

  health() {
    return apiRequest<HealthResponse>("/assistant/health", {
      token: token(),
    });
  },

  tools() {
    return apiRequest<unknown>("/assistant/tools", {
      token: token(),
    });
  },
};
